enum OrganizationNotificationPreferenceNotification {
  OFF = 0,
  PUSH = 1,
  EMAIL = 2,
}

export default OrganizationNotificationPreferenceNotification;
